/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

function attachMethodsToComponent(component, methods) {
  var comp = component;
  for (var method in methods) {
    comp[method] = methods[method];
  }
  return comp;
}

export { attachMethodsToComponent };
//# sourceMappingURL=attachMethodsToComponent.js.map
